module.exports = require("ansi-escapes");


//////////////////
// WEBPACK FOOTER
// external "ansi-escapes"
// module id = 63
// module chunks = 0